import { IInitParam, IConfigParam } from "@dp/byted-tea-sdk-tcpy";

export enum TeaMap {
  try_catch_error = "try_catch_error",
  landing_page_link_jump = "landing_page_link_jump",
  link_tt_tt4b_register_form_item_blur = "link_tt_tt4b_register_form_item_blur",
  link_tt_tt4b_register_form_item_change = "link_tt_tt4b_register_form_item_change",
  landing_page_module_click = "landing_page_module_click",
  landing_page_module_show = "landing_page_module_show",
  landing_page_enter_page = "landing_page_enter_page",
  landing_page_front_screen_visible = "landing_page_front_screen_visible",
  landing_page_page_close = "landing_page_page_close",
  starling_missing_key = "getstarted_starling_missing_key",
  landing_page_adblock_detected = "landing_page_adblock_detected",

  // load events for user sign up and adv account register forms
  link_tt_tt4b_signup_form_load = "link_tt_tt4b_signup_form_load",
  link_tt_tt4b_signup_form_visible = "link_tt_tt4b_signup_form_visible",
  link_tt_tt4b_register_form_load = "link_tt_tt4b_register_form_load",
  link_tt_tt4b_register_form_visible = "link_tt_tt4b_register_form_visible",

  catch_axios_error_detail = "getstarted_catch_axios_error_detail",

  // 后面的为附带的 params
  landing_page_visit = "getstarted_landing_page_visit",
  landing_page_view = "getstarted_landing_page_view",
  click_button = "getstarted_landing_page_click_button", // click_part
  log_in_click = "getstarted_log_in_click", // click_part
  switch_user_click = "getstarted_switch_user_click",
  smb_page_view_check_login_pv = 'smb_page_view_check_login_pv',

  country_next = "getstarted_country_next", // country
  create_user_next = "getstarted_create_user_next",
  create_user_send_code = "getstarted_create_user_send_code",
  // 点击 tt 注册按钮
  create_user_click_tt_oauth_btn = "create_user_click_tt_oauth_btn",

  submit_leave_info = "getstarted_submit_leave_info",
  submit_leave_info_err = "getstarted_submit_leave_info_err", // msg

  submit_registration_form = "getstarted_submit_registration_form",

  // TODO: 以下两个已废弃
  // register_with_phone_btn_click = "getstarted_register_with_phone_btn_click",
  // register_with_email_btn_click = "getstarted_register_with_email_btn_click",
  register_email_complete = "getstarted_register_email_complete", // form_type = "create_user" || "create_adv"
  register_phone_complete = "getstarted_register_phone_complete", // form_type = "create_user" || "create_adv"
  register_password_complete = "register_password_complete",
  register_confirm_password_complete = "register_confirm_password_complete",
  register_verification_code_complete = "register_verification_code_complete",
  register_check_term_complete = "register_check_term_complete",
  register_website_complete = "register_website_complete",

  register_account_country_edit_complete = "register_account_country_edit_complete", // from_country, to_country
  register_account_name_complete = "register_account_name_complete",
  register_step2_agency_complete = "register_step2_agency_complete",
  register_step2_term_check_complete = "register_step2_term_check_complete",
  register_step2_email_term_check_complete = "register_step2_email_term_check_complete",
  // 落地页表单填写
  landing_page_form_input = "landing_page_form_input",
  // 落地页表单提交
  landing_page_form_submit = "landing_page_form_submit",
  // 落地页表单获取验证码
  landing_page_verification_code = "landing_page_verification_code",
  // 落地页user表单选择email类型注册
  register_with_email_btn_click = "register_with_email_btn_click",
  // 落地页user表单选择phnoe类型注册
  register_with_phone_btn_click = "register_with_phone_btn_click",
  // 落地页表单展示
  landing_page_form_show = "landing_page_form_show",

  // FeelGood event tracking
  landing_page_feelgood_shown = "landing_page_feelgood_shown",
  landing_page_feelgood_expanded = "landing_page_feelgood_expanded",
  landing_page_feelgood_closed = "landing_page_feelgood_closed",
  landing_page_feelgood_ready = "landing_page_feelgood_ready",
  landing_page_feelgood_refuse = "landing_page_feelgood_refuse",
  landing_page_feelgood_submit_started = "landing_page_feelgood_submit_started",
  landing_page_feelgood_submit_completed = "landing_page_feelgood_submit_completed",
  landing_page_feelgood_submit_failed = "landing_page_feelgood_submit_failed",

  // referral coupon
  landing_page_referral_coupon_event = "landing_page_referral_coupon_event",

  // APAC agency experiment
  get_started_agency_choice_agency = "get_started_agency_choice_agency",
  get_started_agency_choice_self_serve = "get_started_agency_choice_self_serve",
  get_started_agency_continue_ttam = "get_started_agency_continue_ttam",
  get_started_agency_form_submit = "get_started_agency_form_submit",
  
  tt4b_libra_experiment_group = "tt4b_libra_experiment_group"
}

// Tea.init的固定参数
export const defaultInitParams: IInitParam = {
  app_id: 1583,
  // eslint-disable-next-line no-undef
  channel: TEA_CHANNEL as any,
  // 开启调试日志
  log: process.env.NODE_ENV === "development",
  enable_stay_duration: true // 开启页面停留时长统计
  // maxDuration: 24 * 60 * 60 * 1000 // ms
};

// Tea.config的固定参数
export const defaultConfigParams: IConfigParam = {
  disable_auto_pv: true,
  _staging_flag: IS_PROD ? 0 : 1 // 0正式，1测试（不会进入正式表）
};
